import { createStore, applyMiddleware, compose } from 'redux'
import reducers from '../reducers'
import createSagaMiddleware from 'redux-saga'
import rootSaga from "./rootSaga"

const sagaMiddleware = createSagaMiddleware()


const middleware = process.env.NODE_ENV !== 'production' ?
  [require('redux-immutable-state-invariant').default(), sagaMiddleware] :
  [sagaMiddleware];

const store = createStore(
  reducers,
  compose(applyMiddleware(...middleware))
)
sagaMiddleware.run(rootSaga)

export default store